import styled from "styled-components";
import { Link } from 'react-router-dom';

const StyledEspace = styled.section`
    background: linear-gradient(90deg, #e6f7ff, #b3e0ff);
    padding: 50px 30px;
    color: #003366;
`;

const EspaceWrapper = styled.div`
    max-width: 900px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    gap: 50px;
`;

const BoxVidéo = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; /* aspect ratio 16:9 */
    margin-bottom: 20px;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
`;

const CadreStylisé = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
`;

const TexteDescription = styled.p`
    font-size: 20px;
    line-height: 1.8;
    color: #003366;
    margin-top: 20px;
`;

const BoîteFormulaire = styled.div`
    background: rgba(255, 255, 255, 0.9);
    padding: 35px;
    border-radius: 15px;
    text-align: center;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
`;

const FormulaireInput = styled.form`
    display: flex;
    flex-direction: column;
    gap: 25px;
`;

const ChampInput = styled.input`
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 18px;
    transition: border-color 0.3s;

    &:focus {
        border-color: #0066cc;
        outline: none;
    }
`;

const BoutonSoumettre = styled.button`
    padding: 16px;
    background-color: #0066cc;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #005bb5;
    }
`;

const BoîteAccord = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #003366;
    margin-top: 15px;
    text-align: left;

    input[type="checkbox"] {
        margin-right: 10px;
    }

    a {
        color: #0066cc;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`;

const InfinityComponent = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        fetch("thanks/index.php", {
            method: "POST",
            body: formData,
        }).catch((error) => {
            console.error("Erreur lors de l'envoi du formulaire :", error);
        });

        alert("Demande envoyée");
        e.target.reset();
    };

    return (
        <StyledEspace>
            <EspaceWrapper>
                <div>
                    <BoxVidéo>
                        <CadreStylisé
                            src="https://www.youtube.com/embed/NWus8pVPXaI?si=kroWFELXVhLprqeN"
                            title="Vidéo de France Investment"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </BoxVidéo>
                    <TexteDescription>
                        France Investment est une plateforme dédiée à l'éducation économique et à la promotion de la pensée à long terme. Nous croyons fermement au pouvoir de la littératie financière pour transformer des vies et ouvrir la voie à des opportunités nouvelles. Explorez avec nous des concepts tels que la stabilité financière et le développement personnel, tout en bâtissant un avenir plein de promesses.
                    </TexteDescription>
                </div>
                <BoîteFormulaire>
                    <h3 style={{ marginBottom: "25px", color: "#003366" }}>Inscription</h3>
                    <FormulaireInput onSubmit={handleSubmit}>
                        <ChampInput
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Entrez votre nom"
                            required
                        />
                        <ChampInput
                            type="text"
                            id="surname"
                            name="surname"
                            placeholder="Entrez votre prénom"
                            required
                        />
                        <ChampInput
                            type="email"
                            id="email"
                            name="email"
                            placeholder="exemple@mail.com"
                            required
                        />
                        <ChampInput
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder="+33 600 000 000"
                            required
                        />
                        <BoîteAccord>
                            <input type="checkbox" id="terms" name="terms" required />
                            <label htmlFor="terms">
                                J'accepte les{" "}
                                <Link to="/terms" rel="noopener noreferrer">
                                    Conditions Générales
                                </Link>{" "}
                                et la{" "}
                                <Link to="/cookies" rel="noopener noreferrer">
                                    Politique de Cookies
                                </Link>{" "}
                                et la{" "}
                                <Link to="/policy" rel="noopener noreferrer">
                                    Politique de Confidentialité
                                </Link>
                            </label>
                        </BoîteAccord>
                        <BoutonSoumettre type="submit">Soumettre la Demande</BoutonSoumettre>
                    </FormulaireInput>
                </BoîteFormulaire>
            </EspaceWrapper>
        </StyledEspace>
    );
};
export default InfinityComponent;